<template>
  <div>
    <v-btn color="primary" dark class="mb-2 hbtn" to="/hotels/store"
      >{{ $t("companiesPage.newHotel") }}</v-btn
    >
    <DataTable
      ref="hotelDataTable"
      :url="api.ACTIONS.HOTEL"
      :titles="titles"
      :fields-hidden-add="['created_at', 'updated_at']"
      :title="$t('companiesPage.tableHotels')"
      :enableEdit="false"
      :enableAdd="false"
      :enableDelete="false"
      :add-rules="rules"
      :actions-extra-main="actionsExtraMain"
    />
  </div>
</template>

<style>
.hbtn {
  float: inline-end;
  z-index: 1;
  margin-top: 20px;
  margin-inline-end: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";

export default {
  name: "Hotels",
  title() {
    return this.$t("companiesPage.hotelsPageTitle");
  },
  components: { DataTable },
  data() {
    return {};
  },

  computed: {
    rules() {
      return {
        name: [required],
      };
    },
    titles() {
      return {
        id: this.$t("companiesPage.colId"),
        name: this.$t("companiesPage.colName"),
        address: this.$t("companiesPage.colAddress"),
        landmark: this.$t("companiesPage.colLandmark"),
      };
    },
    actionsExtraMain() {
      return {
        editHotel: {
          title: this.$t("companiesPage.editHotel"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "EditHotel",
              params: { id: item.id },
            }),
        },
        deleteHotel: {
          title: this.$t("companiesPage.deleteHotel"),
          icon: "delete_forever",
          action: ({ id }) => {
            this.loading = true;
            this.axios
              .delete(`hotel/${id}`)
              .then((res) => {
                window.getApp.$emit(
                  "SHOW_TOAST",
                  this.$t("companiesPage.toastHotelDeleted"),
                  "green"
                );
                this.$refs.hotelDataTable.getData();
              })
              .catch((err) => {
                let response = err.response;
                if (response) {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    response.data.message,
                    "red"
                  );
                } else {
                  window.getApp.$emit(
                    "SHOW_TOAST",
                    this.$t("companiesPage.toastSomethingWrong"),
                    "red"
                  );
                }
              })
              .finally(() => (this.loading = false));
          },
        },
      };
    },
  },
};
</script>
